export default __webpack_public_path__ + "static/media/profile.9fa80322.png";